import _extends from '../../../../node_modules/@babel/runtime/helpers/extends.js';
import _objectWithoutProperties from '../../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { forwardRef, useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import { useReactlyticsHandlers } from '@americanexpress/reactlytics';
import merge from 'deepmerge';
import btnReset from '../../../utils/styles.js';
import btn from '../../../styles/btn.js';

var ButtonBase = /*#__PURE__*/forwardRef(function (props, ref) {
  var _useReactlyticsHandle = useReactlyticsHandlers(props, ['onClick']),
      children = _useReactlyticsHandle.children,
      theme = _useReactlyticsHandle.theme,
      styled = _useReactlyticsHandle.styled,
      size = _useReactlyticsHandle.size,
      otherProps = _objectWithoutProperties(_useReactlyticsHandle, ["children", "theme", "styled", "size"]);

  var cssStyle = useMemo(function () {
    return merge.all([btnReset, styled ? btn.btn : {}, size === 'sm' ? btn.btnSm : {}, theme]);
  }, [size, theme, styled]);
  return (// eslint-disable-next-line react/button-has-type
    jsx("button", _extends({
      css: cssStyle
    }, otherProps, {
      ref: ref
    }), children)
  );
});
ButtonBase.displayName = 'ButtonBase';
ButtonBase.defaultProps = {
  children: '',
  size: undefined,
  type: 'button',
  theme: {}
};

export default ButtonBase;
